import React, { Dispatch } from 'react';
import { createContext, useContext, useContextSelector } from 'use-context-selector';
import { IActions } from './DashboardMaintenanceEnquiry.actions';
import reducer, { initialState, IState } from './DashboardMaintenanceEnquiry.reducer';

export const DashboardMaintenanceEnquiry = createContext<IState>(initialState);
export const DashboardMaintenanceEnquiryDispatchContext = createContext<Dispatch<IActions>>(() => null);

export const useDMEDispatch = () => useContext(DashboardMaintenanceEnquiryDispatchContext);
export const useDMEState = () => useContext(DashboardMaintenanceEnquiry);
export const useDMEContextSelector = <K extends keyof IState>(selector: (state: IState) => IState[K]) => useContextSelector<IState, IState[K]>(DashboardMaintenanceEnquiry, selector);

interface IPickSlipsStateProvider {
  children: React.ReactNode;
}

const DashboardMaintenanceEnquiryProvider = ({ children }: IPickSlipsStateProvider) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <DashboardMaintenanceEnquiry.Provider value={state}>
      <DashboardMaintenanceEnquiryDispatchContext.Provider value={dispatch}>
        {children}
      </DashboardMaintenanceEnquiryDispatchContext.Provider>
    </DashboardMaintenanceEnquiry.Provider>
  );
};

export default DashboardMaintenanceEnquiryProvider;
